import axios from 'axios';
import i18n from '../../../translation/i18n';
import { format } from 'date-fns';
// utcToZonedTime(step.start_date, 'Etc/UTC');

interface getRoomProductListingParams {
    real_stock_id: number;
    room_id?: number;
    contract_id?: number;
    date?: Date;
}

export const getRoomProductListing = ({real_stock_id, room_id, contract_id, date}: getRoomProductListingParams, client_id: number) => axios({
    method: 'GET',
    url: `${API_HREF}client/${client_id}/custom-accommodations/room_product_listing/`,
    headers: {
        'Authorization': `Token ${localStorage.getItem('token')}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language
    },
    params: {
        real_stock_id,
        room_id,
        contract_id,
        date: date? format(date, 'yyyy-MM-dd'): undefined
    }
});